import { render, staticRenderFns } from "./TokenItem.vue?vue&type=template&id=c8864d60&scoped=true&"
import script from "./TokenItem.vue?vue&type=script&lang=js&"
export * from "./TokenItem.vue?vue&type=script&lang=js&"
import style0 from "./TokenItem.vue?vue&type=style&index=0&id=c8864d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8864d60",
  null
  
)

export default component.exports